import { type CSSProperties, useMemo } from 'react';
import { Layout, theme } from 'antd';
import {
  AppHeader,
  type AppHeaderProps,
} from 'pos-client/layouts/app/AppHeader.tsx';
import { isPosPageHeader } from 'pos-client/utils/layoutUtils.ts';

import { PosPageContent, type PosPageContentProps } from './PosPageContent.tsx';

type PosPageStylesType = {
  content?: CSSProperties;
  header?: CSSProperties;
  footer?: CSSProperties;
  root?: CSSProperties;
};

type HeaderFooterProps = Omit<AppHeaderProps, 'style'> &
  Omit<PosPageContentProps, 'style' | 'footerStyle'>;

interface PosPageProps extends HeaderFooterProps {
  styles?: PosPageStylesType;
  loading?: boolean;
}

export const PosPage = ({
  children,
  styles,
  row,
  rowProps,
  hideFooter,
  loading = false,
  ...headerProps
}: PosPageProps) => {
  const { token } = theme.useToken();
  const hasHeader = !!headerProps;
  const hasTabBar = isPosPageHeader(headerProps?.header)
    ? !!headerProps.header.tabBar
    : false;

  const pageContentProps: CSSProperties = useMemo(
    () => ({
      ...styles?.content,
      ...(!hasTabBar && {
        paddingTop: token.paddingXS,
      }),
    }),
    [hasTabBar, styles?.content, token.paddingXS]
  );

  return (
    <Layout style={{ width: '30%', ...styles?.root }}>
      {hasHeader && <AppHeader loading={loading} {...headerProps} />}
      <PosPageContent
        row={row}
        rowProps={rowProps}
        hideFooter={hideFooter}
        footerStyle={styles?.footer}
        style={{ ...pageContentProps }}
      >
        {children}
      </PosPageContent>
    </Layout>
  );
};
